<template>
    <div class="chart-analytics-num-practice">
        <div class="chart-analytics-num-practice__header">
            <span class="chart-analytics-num-practice__header-icon"></span>
            <div class="chart-analytics-num-practice__heading">
                <span class="chart-analytics-num-practice__heading-period">{{ textHeadingPeriod }}</span>
                <span class="chart-analytics-num-practice__heading-text">Pratik Sayısı Gelişimi</span>
            </div>
        </div>
        <div class="chart-analytics-num-practice__wr-chart">
            <div
                v-if="showPreloader"
                class="chart-analytics-num-practice__preloader"></div>
            <canvas
                v-if="!showPreloader"
                id="chart-analytics-num-practice__chart"></canvas>
        </div>
        <div
            v-if="!showPreloader"
            class="chart-analytics-num-practice__legend">
            <span class="chart-analytics-num-practice__legend-icon"></span>
            <span class="chart-analytics-num-practice__legend-text">pratik sayısı</span>
        </div>
    </div>
</template>
<script>
    import Chart from 'chart.js/auto';
    let chartInstance = null;

    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            filteredChartNumPracticeData(){
                if(this.showPreloader){
                    return null;
                }
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.numPracticeMode.type;
                return this.$store.state.response.analyticsPractice.chartNumPracticeData[selectedFiltertagType];
            },

            textHeadingPeriod(){
                let selectedFiltertagType = this.$store.state.selectedFiltertag.analyticsPractice.numPracticeMode.type;
                if(selectedFiltertagType === 'weekly'){
                    return 'HAFTALIK';
                }
                else if(selectedFiltertagType === 'monthly'){
                    return 'AYLIK';
                }
                else if(selectedFiltertagType === 'yearly'){
                    return 'YILLIK';
                }
            }
        },

        watch: {
            filteredChartNumPracticeData: {
                handler(nv, ov){
                    if(!this.filteredChartNumPracticeData){
                        return;
                    }
                    if(!chartInstance){
                        return;
                    }
                    this.$nextTick(() => {
                        chartInstance.destroy();
                        this.createChart();
                    });
                },
                deep: true
            }
        },

        methods: {
            createChart(){
                Chart.defaults.font.family = "Overpass";
                chartInstance = new Chart(document.querySelector('#chart-analytics-num-practice__chart'), {
                    type: 'line',
                    data: {
                        labels: this.filteredChartNumPracticeData.labels,
                        datasets: [{
                            label: 'pratik sayısı',
                            data: this.filteredChartNumPracticeData.data,
                            borderWidth: 2,
                            borderColor: '#2779ED',
                            pointRadius: 2.5,
                            pointBackgroundColor: '#2779ED',
                            cubicInterpolationMode: 'monotone',
                            fill: true,
                            backgroundColor: (context) => {
                                if(!context.chart.chartArea){return;}
                                let chartArea = context.chart.chartArea;
                                let ctx = context.chart.ctx;
                                let gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                                gradient.addColorStop(0, 'rgba(39, 121, 237, 0.35)');
                                gradient.addColorStop(1, 'rgba(39, 121, 237, 0.05)');
                                return gradient;
                            }
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                border: {
                                    color: '#A0B8EB'
                                },
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    font: {
                                        size: 11
                                    },
                                }
                            },
                            y: {
                                border: {
                                    display: false,
                                },
                                grid: {
                                    color: '#CCCCCC',
                                    lineWidth: 1
                                },
                                ticks: {
                                    font: {
                                        size: 11
                                    },
                                    maxTicksLimit: 3,
                                },
                                beginAtZero: true
                            }
                        },
                        plugins: {
                            legend: {
                                display: false,
                            }
                        }
                    },
                });
            }
        },
        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsChartNumPractice)
                .then(response => response.json())
                .then(chartNumPracticeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'chartNumPracticeData',
                        data: chartNumPracticeData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPracticeChartNumPractice, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(chartNumPracticeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPractice',
                        dataLabel: 'chartNumPracticeData',
                        data: chartNumPracticeData
                    });
                    this.showPreloader = false;
                    this.$nextTick(() => {
                        this.createChart();
                    });
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                })
            }
        }
    };
</script>
<style scoped src="@/css/components/chart-analytics-num-practice.css"></style>